
  import { Component } from 'vue-property-decorator'
  import BaseStepper from '@/components/forms/inspection/base/BaseStepper.vue'

@Component
  export default class BasePanel extends BaseStepper {
  }
